import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";
import { reusableFetch } from "@/utils/useFetch";
import type { LenderCardsSlice, Tooltip } from "./types/lenderCards";

export const getAllLenders = createAsyncThunk("lenderCards/getAllLenders", async (data, { rejectWithValue }) => {
  const lenders = await reusableFetch(`lender/all`, "GET", null, rejectWithValue);
  return lenders;
});

const initialTooltip: Tooltip = {
  lenderId: undefined,
  isOpen: false,
  type: undefined,
};

const initialState: LenderCardsSlice = {
  tooltip: initialTooltip,
  lenders: [],
  gettingAllLenders: false,
};

export const lenderCardsSlice = createSlice({
  name: "lenderCards",
  initialState,
  reducers: {
    setLenderCardsTooltip: (state, action: PayloadAction<Tooltip>) => {
      return {
        ...state,
        tooltip: action.payload,
      };
    },
    resetLenderCardsTooltip: (state) => {
      return {
        ...state,
        tooltip: initialTooltip,
      };
    },
    resetLenderCards: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllLenders.fulfilled, (state, { payload }) => {
        // @ts-expect-error: ignoring as this is existing code
        state.lenders = payload?.data?.data;
        state.gettingAllLenders = false;
      })
      .addCase(getAllLenders.rejected, (state) => {
        state.gettingAllLenders = false;
      })
      .addCase(getAllLenders.pending, (state) => {
        state.gettingAllLenders = true;
      });
  },
});

export const { setLenderCardsTooltip, resetLenderCardsTooltip, resetLenderCards } = lenderCardsSlice.actions;

export const lenderCardsSelector = (state: RootState) => state.lenderCards;

export default lenderCardsSlice.reducer;
